import predictify from './predictify-phone-mockuup.png';
import slotngo from './slotngo-macpro.png';

export default function Projects() {
  return (
    <div>
      <div className="bg-transparent mt-5">
        <section className="bg-transparent py-3 py-md-5 min-vh-100" id="projects">
          <div className="container">
            <div className="row justify-content-md-center">
              <div className="col-12 col-md-10 col-lg-8 col-xl-7 col-xxl-6">
                <h2 className="mb-4 display-5 text-center text-light">Latest Projects</h2>
                <hr className="w-50 mx-auto mb-5 mb-xl-9 border-light-subtle" />
              </div>
            </div>
            <div className="row g-4">
              {/* Predictify Card */}
              <div className="col-12 col-md-6 mb-5">
                <div className="card bg-transparent text-light h-100 border-0">
                  <a href="https://predictify.app" target="_blank" rel="noopener noreferrer">
                    <img
                      src={predictify}
                      className="card-img-top"
                      alt="Predictify"
                      style={{ objectFit: 'contain', height: '375px', width: '100%' }} // 50% bigger
                    />
                  </a>
                  <div className="card-body">
                    <h4 className="card-title text-center">Predictify</h4>
                    <hr className="w-50 mx-auto  mb-3 border-light-subtle" />

                    <p className="card-text text-center">
                    Predictify is an AI-powered app that offers accurate predictions for fantasy sports and real-world matchups, allowing users to make informed decisions and compete with friends in exciting sports prediction games.                    </p>
                  </div>
                </div>
              </div>
              {/* SlotNGo Card */}
              <div className="col-12 col-md-6 mb-5">
                <div className="card bg-transparent text-light h-100 border-0">
                  <a href="https://slotngo.com" target="_blank" rel="noopener noreferrer">
                    <img
                      src={slotngo}
                      className="card-img-top"
                      alt="SlotNGo"
                      style={{ objectFit: 'contain', height: '375px', width: '100%' }} // 25% bigger
                    />
                  </a>
                  <div className="card-body">
                    <h4 className="card-title text-center">SlotNGo</h4>
                    <hr className="w-50 mx-auto  mb-3 border-light-subtle" />

                    <p className="card-text text-center">
                    SlotNGo is an online casino that offers a wide range of slot games and casino experiences, providing users with an exciting and immersive gaming environment right from their devices.

                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
